/**
 * Modul ritchtext / template "circles".
 * Cele 4 buline gliseaza pe propriile axe diagonale, intre cele 3 inele concentrice.
 * Cand bulina trasata schimba inelul, celelalte 3 se muta conform $relationships
 * (transmis ca JSON in data-relationships pe sectiune).
 */
$(document).ready(function () {

    const HALF       = 300;                    // jumatate din viewBox-ul SVG (600 / 2)
    const MAX_DIST   = 280;                    // raza maxima (marginea inelului negru)
    const LEVEL_DIST = { scazut: 60, mediu: 160, ridicat: 240 };

    function levelFromDist(d) {
        if (d < 120) return 'scazut';
        if (d < 200) return 'mediu';
        return 'ridicat';
    }

    function axisVec(angleDeg) {
        const r = angleDeg * Math.PI / 180;
        return { x: Math.cos(r), y: Math.sin(r) };
    }

    $('.template-richtext--circles').each(function () {
        const $section = $(this);
        const $board   = $section.find('[data-circles-board]');
        if ($board.length === 0) { return; }

        let relationships = {};
        try {
            relationships = JSON.parse($section.attr('data-relationships') || '{}');
        } catch (e) { /* config invalid -> fara cascade */ }

        const state    = {};
        const $bullets = $board.find('.bullet');
        let dragging   = null;

        function placeAtDist(key, dist) {
            const v   = axisVec(state[key].angle);
            const xPc = 50 + (v.x * dist / HALF) * 50;
            const yPc = 50 + (v.y * dist / HALF) * 50;
            state[key].$el.css({ left: xPc + '%', top: yPc + '%' });
        }

        function updateLegend(key, level) {
            const $legend = $section.find('.legend[data-legend="' + key + '"]');
            $legend.find('.lvl').each(function () {
                const $lvl = $(this);
                $lvl.toggleClass('is-active', $lvl.attr('data-level') === level);
            });
        }

        function placeAtLevel(key, level) {
            state[key].level = level;
            state[key].$el.attr('data-level', level);
            placeAtDist(key, LEVEL_DIST[level]);
            updateLegend(key, level);
        }

        function cascade(movedKey, newLevel) {
            const map = relationships[movedKey] && relationships[movedKey][newLevel];
            if (!map) { return; }
            Object.keys(map).forEach(function (k) {
                if (k === movedKey) { return; }
                placeAtLevel(k, map[k]);
            });
        }

        function mouseToDist(clientX, clientY, angle) {
            const rect = $board[0].getBoundingClientRect();
            const cx   = rect.left + rect.width  / 2;
            const cy   = rect.top  + rect.height / 2;
            // raportul intre unitati viewBox si pixeli reali
            const scale = HALF / (rect.width / 2);
            const dx = (clientX - cx) * scale;
            const dy = (clientY - cy) * scale;
            const v  = axisVec(angle);
            let dist = dx * v.x + dy * v.y;
            if (dist < 0)        { dist = 0; }
            if (dist > MAX_DIST) { dist = MAX_DIST; }
            return dist;
        }

        // initializare pozitii
        $bullets.each(function () {
            const $el = $(this);
            const key = $el.attr('data-bullet');
            state[key] = {
                angle: parseFloat($el.attr('data-angle')),
                level: $el.attr('data-level'),
                $el:   $el,
            };
            placeAtLevel(key, state[key].level);
        });

        // start drag
        $bullets.on('mousedown', function (e) {
            const key = $(this).attr('data-bullet');
            dragging = { key: key, startLevel: state[key].level, lastDist: LEVEL_DIST[state[key].level] };
            $(this).addClass('is-dragging');
            e.preventDefault();
        });

        $bullets.each(function () {
            this.addEventListener('touchstart', function (e) {
                const key = this.getAttribute('data-bullet');
                dragging = { key: key, startLevel: state[key].level, lastDist: LEVEL_DIST[state[key].level] };
                this.classList.add('is-dragging');
            }, { passive: true });
        });

        // move drag
        $(document).on('mousemove', function (e) {
            if (!dragging) { return; }
            const dist = mouseToDist(e.clientX, e.clientY, state[dragging.key].angle);
            placeAtDist(dragging.key, dist);
            updateLegend(dragging.key, levelFromDist(dist));
            dragging.lastDist = dist;
        });

        document.addEventListener('touchmove', function (e) {
            if (!dragging) { return; }
            const t = e.touches[0];
            if (!t) { return; }
            const dist = mouseToDist(t.clientX, t.clientY, state[dragging.key].angle);
            placeAtDist(dragging.key, dist);
            updateLegend(dragging.key, levelFromDist(dist));
            dragging.lastDist = dist;
            e.preventDefault();
        }, { passive: false });

        // end drag - snap la cel mai apropiat nivel + cascade
        function endDrag() {
            if (!dragging) { return; }
            const key      = dragging.key;
            const newLevel = levelFromDist(dragging.lastDist);
            state[key].$el.removeClass('is-dragging');
            placeAtLevel(key, newLevel);
            if (newLevel !== dragging.startLevel) {
                cascade(key, newLevel);
            }
            dragging = null;
        }

        $(document).on('mouseup', endDrag);
        document.addEventListener('touchend',    endDrag);
        document.addEventListener('touchcancel', endDrag);

        // re-pozitionare la resize (procentul ramane corect, dar refresh-ul evita drift)
        $(window).on('resize', function () {
            Object.keys(state).forEach(function (key) {
                placeAtDist(key, LEVEL_DIST[state[key].level]);
            });
        });
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/circles.js